module.exports = __webpack_public_path__ + "img/People.980e7324.png";